import useEvent from "./use-event";

const useReplaceableEvent = useEvent;
export default useReplaceableEvent;
